import {create} from 'zustand';
import {HideSearchBarStore} from './types';

const useHideSearchBarStore = create<HideSearchBarStore>(set => ({
	hideSearchBar: false,
	setHideSearchBar: value => set({hideSearchBar: value}),
}));

export {useHideSearchBarStore};
